const { createTheme } = require("@mui/material/styles");

const defaultTheme = createTheme();

const fontFamily = [
	"Open Sans",
	"-apple-system",
	"BlinkMacSystemFont",
	'"Segoe UI"',
	'"Helvetica Neue"',
	"Arial",
	"sans-serif",
	'"Apple Color Emoji"',
	'"Segoe UI Emoji"',
	'"Segoe UI Symbol"',
].join(",");

const themeConfig = {
	shape: {
		borderRadius: 3,
	},
	palette: {
		body: {
			main: "#ffffff",
			light: "#f5f5f5",
			dark: "#e0e0e0",
			contrastText: "#000000",
		},
		subnav: {
			contrastText: "#757575",
			main: "#fafafa",
			light: "#E7E7E7",
		},
		appBar: {
			public: {
				main: "#2c0065",
				light: "#2c0065",
				dark: "#2c0065",
				contrastText: "#ffffff",
				gradient: "linear-gradient(90deg, #2c0065, #622c6d)",
			},
		},
		titleBar: {
			public: {
				main: "#2c0065",
				light: "#2c0065",
				dark: "#2c0065",
				contrastText: "#ffffff",
				gradient: `url('/texture.png'), linear-gradient(90deg, #502970 30%, #7a1988)`,
			},
		},
		primary: {
			main: "#6e4094",
			light: "#502970",
			dark: "#391b52",
			contrastText: "#ffffff",
		},
		tab: {
			main: "#37236a",
			light: "#7a1988",
			paper: "#eeeeee",
			contrastText: "#ffffff",
		},
		secondary: {
			main: "#7a1988",
			light: "#a44db0",
			dark: "#590e63",
			contrastText: "#ffffff",
		},
		closingHeadingsSecond: {
			main: "#6e4094",
			light: "#502970",
			dark: "#391b52",
			contrastText: "#ffffff",
		},
		closingHeadings: {
			main: "#7a1988",
			light: "#a44db0",
			dark: "#590e63",
			contrastText: "#ffffff",
		},
		underline: {
			main: "#f6b600",
		},
		footer: {
			light: "#4e5a66",
			main: "#333d47",
			dark: "#20272e",
			contrastText: "#ffffff",
		},
		colophon: {
			light: "#20272e",
			main: "#20272e",
			dark: "#20272e",
			contrastText: "#ffffff",
		},
		link: {
			main: "#0472b0",
			light: "#016197",
			dark: "#00466e",
		},
		excerptLink: {
			main: "#000000",
			light: "#000000",
			dark: "#000000",
		},

		highlight: {
			light: "rgba(255, 255, 255, 0.85)",
		},
	},
	components: {
		MuiButton: {
			styleOverrides: {
				contained: {
					fontWeight: 600,
				},
			},
		},
	},
	typography: {
		fontWeightBold: 600,
		fontFamily,
		subtitle2: {
			fontFamily,
			fontWeight: 600,
			opacity: 1,
			color: "#000000",
		},
		nav: {
			fontFamily,
			fontSize: "0.75rem",
			textTransform: "uppercase",
			fontWeight: 600,
		},
		subnav: {
			textTransform: "none",
		},
		toolsNav: {
			fontFamily,
			fontSize: "0.7rem",
			textTransform: "uppercase",
		},
		caption: {
			fontFamily,
			fontSize: "0.75rem",
		},
		h1: {
			fontFamily,
			fontWeight: 400,
			fontSize: "2rem",
		},
		h2: {
			fontFamily,
			fontWeight: 600,
			fontSize: "1.8rem",
		},
		h3: {
			fontFamily,
			fontWeight: 600,
			fontSize: "1.6rem",
		},
		h4: {
			fontWeight: 600,
			fontSize: "1.4rem",
			fontFamily,
		},
		h5: {
			fontWeight: 600,
			fontSize: "1.2rem",
			fontFamily,
		},
		h6: {
			fontWeight: 600,
			fontSize: "0.75rem",
			fontFamily,
		},
		titleBar: {
			fontFamily,
		},
		brandTitle: {
			fontFamily,
		},
		brandSubtitle: {
			fontFamily,
		},
		subtitle1: {
			fontStyle: "normal",
			fontWeight: 400,
			lineHeight: 1.5,
			letterSpacing: "-0.01562em",
			fontSize: "1.3rem",
			fontFamily,
		},
	},
	cloverleaf: {
		googleFont: "Open+Sans:ital,wght@0,400;0,600;1,400;1,600",
		css: `
      #___gatsby .desktop-nav {
        position: relative;
      }

      #___gatsby .desktop-nav::before {
        content: " ";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background-image: -webkit-gradient(
          linear,
          left top,
          right top,
          color-stop(28%, rgba(255, 255, 255, 0.01)),
          to(rgba(255, 255, 255, 0.21))
        );
        background-image: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0.01) 28%,
          rgba(255, 255, 255, 0.21)
        );
        z-index: 1;
      }
    `,
		navbar: {
			padding: 1,
			align: "right",
			borderRadius: 9,
		},
		sidebar: {
			style: "box",
			underline: "#ffc700",
			underlineStyle: "rounded",
		},
		footer: {
			disableBrand: true,
		},
		list: {
			underline: "#ffc700",
			underlineStyle: "rounded",
		},
		single: {
			bannerOrientation: "full",
		},
		image: {
			aspectRatio: {
				banner: "25 / 7",
			},
		},
		highlight: {
			inlineButtonsThreshold: 3,
		},
		brand: {
			size: 38,
			logoFooterSize: 96,
		},
		closingHeadingsStyled: true,
		closingHeadingsFlatColor: false,
	},
};
module.exports = themeConfig;
